import React, { useState, ChangeEvent, useEffect } from "react";
import { TextField, Typography } from "@mui/material";

interface CustomMultiLineTextAreaProps {
  initialValue?: string;
  onChange?: (value: string) => void;
  maxWords?: number;
  description?: string;
  placeholder?: string;
}

const CustomMultiLineTextArea: React.FC<CustomMultiLineTextAreaProps> = ({
  initialValue = "",
  onChange,
  maxWords = 2000,
  description = "Please provide more information (max 2000 words).",
  placeholder = "Type description here",
}) => {
  const [text, setText] = useState<string>(initialValue);
  const [wordCount, setWordCount] = useState<number>(
    initialValue.trim().split(/\s+/).filter(Boolean).length
  );
  const [error, setError] = useState<string>("");
  
  useEffect(() => {
    setText(initialValue);
    setWordCount(initialValue.trim().split(/\s+/).filter(Boolean).length);
  }, [initialValue]);

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value;
    const words = value.trim().split(/\s+/).filter(Boolean);
    if (words.length <= maxWords) {
      setText(value);
      setWordCount(words.length);
      setError("");
      if (onChange) onChange(value);
    } else {
      setError(`Description must be ${maxWords} words or less.`);
    }
  };

  return (
    <div>
      <TextField
        value={text}
        onChange={handleChange}
        placeholder={placeholder}
        multiline
        minRows={8}
        fullWidth
        variant="outlined"
        error={Boolean(error)}
        helperText={error || description}
        sx={{fontFamily:"Plus Jakarta Sans", fontWeight:"100"}}
        FormHelperTextProps={{
            sx: {
              fontFamily: "Plus Jakarta Sans, sans-serif",
            },
          }}
      />
      <Typography
        variant="caption"
        sx={{ display: "block", textAlign: "right", color: "#666", mt: 0.5, fontFamily:'Plus Jakarta Sans' }}
      >
        {wordCount} / {maxWords} words
      </Typography>
    </div>
  );
};

export default CustomMultiLineTextArea;
